import { render, staticRenderFns } from "./OzLoadingText.vue?vue&type=template&id=5ef2a507&scoped=true&"
import script from "./OzLoadingText.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzLoadingText.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OzLoadingText.vue?vue&type=style&index=0&id=5ef2a507&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2a507",
  null
  
)

export default component.exports